import * as types from '../../lib/actionTypes.es6';

export function getEngineFlowsRequest(partner) {
  return { type: types.GET_ENGINE_FLOWS_REQUEST, payload: partner };
}
export function getEngineFlowsSuccess(flows) {
  return { type: types.GET_ENGINE_FLOWS_SUCCESS, payload: flows };
}
export function getEngineFlowsFail(error) {
  return { type: types.GET_ENGINE_FLOWS_FAIL, payload: error };
}

export function getEngineFlowRawRequest(partner, flowId) {
  return { type: types.GET_ENGINE_FLOW_RAW_REQUEST, payload: { partner, flowId } };
}
export function getEngineFlowRawSuccess(raw) {
  return { type: types.GET_ENGINE_FLOW_RAW_SUCCESS, payload: raw };
}
export function getEngineFlowRawFail(error) {
  return { type: types.GET_ENGINE_FLOW_RAW_FAIL, payload: error };
}
export function getEngineFlowRawReset() {
  return { type: types.GET_ENGINE_FLOW_RAW_RESET };
}

export function publishEngineFlowRequest(partner, flowId, rawYaml) {
  return { type: types.PUBLISH_ENGINE_FLOW_REQUEST, payload: { partner, flowId, rawYaml } };
}
export function publishEngineFlowSuccess(result) {
  return { type: types.PUBLISH_ENGINE_FLOW_SUCCESS, payload: result };
}
export function publishEngineFlowFail(error) {
  return { type: types.PUBLISH_ENGINE_FLOW_FAIL, payload: error };
}
export function publishEngineFlowReset() {
  return { type: types.PUBLISH_ENGINE_FLOW_RESET };
}

export function createEngineFlowRequest(partner, rawYaml) {
  return { type: types.CREATE_ENGINE_FLOW_REQUEST, payload: { partner, rawYaml } };
}
export function createEngineFlowSuccess(result) {
  return { type: types.CREATE_ENGINE_FLOW_SUCCESS, payload: result };
}
export function createEngineFlowFail(error) {
  return { type: types.CREATE_ENGINE_FLOW_FAIL, payload: error };
}
export function createEngineFlowReset() {
  return { type: types.CREATE_ENGINE_FLOW_RESET };
}
